import { useSelector, useDispatch } from "react-redux";
import { useCallback, useEffect } from "react";

import { RecordAreaType, RecordType } from "../api/consts";
import { setRecordAreaFilterTypes } from "../redux/records/recordsReducer";

// get values from RecordAreaType
const possibleFilters = Object.values(RecordAreaType);

export const getFilters = (allowedRecordTypes) => {
  if (allowedRecordTypes.length === 0) {
    return [];
  }

  if (allowedRecordTypes.includes(RecordType.AREA)) {
    return possibleFilters;
  }
  return [];
};

const useFilterRecords = () => {
  const dispatch = useDispatch();

  const { filterAreaTypes } = useSelector((state) => state.records);

  const setFilterTypes = useCallback(
    (types) => {
      dispatch(setRecordAreaFilterTypes(types));
    },
    [dispatch],
  );

  useEffect(() => {
    setFilterTypes([]);
  }, [setFilterTypes]);

  const toggleFilterType = useCallback(
    (type, { on = false, off = false, toggle = undefined } = {}) => {
      if (on) {
        toggle = true;
      }

      if (off) {
        toggle = false;
      }

      if (toggle === undefined) {
        toggle = !filterAreaTypes.includes(type);
      }

      if (toggle) {
        setFilterTypes([...filterAreaTypes, type]);
      } else {
        setFilterTypes(filterAreaTypes.filter((t) => t !== type));
      }
    },
    [filterAreaTypes, setFilterTypes],
  );

  return [filterAreaTypes, toggleFilterType];
};

export default useFilterRecords;
